// extracted by mini-css-extract-plugin
export var root = "page-module--root--Zjt9U";